module.exports = __webpack_public_path__ + "img/1696382181457-NIB SAMBAL ZAHRA.png.64c5cd8d.webp";